import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'sb-valuelink'
import cx from 'classnames'

import s from './RadioButton.scss'


class RadioButton extends Component {

  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    disabled: PropTypes.bool,
    brand: PropTypes.bool,
    ariaLabelledBy: PropTypes.string,
  }

  static contextTypes = {
    radioGroup: PropTypes.object,
  }

  render() {
    const { radioGroup: { name, valueLink } } = this.context
    const { children, className, brand, disabled, value, dataTestId, ariaLabelledBy } = this.props

    const rootClassName = cx(s.root, className, {
      [s.brand]: brand,
      [s.disabled]: disabled,
    })

    return (
      <label className={rootClassName}>
        <Input
          value={value}
          className={s.input}
          type="radio"
          name={name}
          disabled={disabled}
          valueLink={valueLink}
          data-testid={dataTestId}
          aria-labelledby={ariaLabelledBy}
        />
        <div className={s.radio} />
        {children && <span className={s.label}>{children}</span>}
      </label>
    )
  }
}


export default RadioButton
